import {useState, useEffect, useCallback, useMemo} from 'react';
import AdminPermission from 'Admin/Presentation/AdminPermission';
import {findTeams} from 'Teams/service/TeamService';
import {findAces, saveAce} from 'Users/service/UserService';

export default function AdminPermissionContainer(props) {
  const [teams, setTeams] = useState([]);
  const [aces, setAces] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const handleRetrieveAces = useCallback(async () => {
    const {id} = selectedUser;
    const newAces = await findAces(id);

    setAces(newAces);
  }, [selectedUser]);
  const handleSaveAce = async (row, col) => {
    const ace = aces[row];

    switch (col) {
      case 1:
        ace.canread = !ace.canread;
        break;
      case 2:
        ace.canwrite = !ace.canwrite;
        break;
      case 3:
        ace.candelete = !ace.candelete;
        break;
      default:
        break;
    }
    await saveAce(ace);
    handleRetrieveAces(selectedUser);
  };
  const handleAddAce = (team) => {
    const newAce = buildAce(team);

    setAces([...aces, newAce]);
  };
  const buildAce = (team) => {
    const {id} = selectedUser;

    return {
      canread: false,
      canwrite: false,
      candelete: false,
      team,
      user: {
        id,
      },
    };
  };
  const handleChangeSelectedUser = (user) => setSelectedUser(user);
  const filteredTeams = useMemo(
    () => teams.filter(({id}) => aces.every((ace) => ace.team.id !== id)),
    [aces, teams],
  );

  useEffect(() => {
    const handleRetrieveTeams = async () => {
      const teams = await findTeams();

      setTeams(teams);
    };

    !!selectedUser && handleRetrieveTeams();
  }, [selectedUser]);

  useEffect(() => {
    if (!!selectedUser) handleRetrieveAces();
  }, [handleRetrieveAces, selectedUser]);

  return (
    <AdminPermission
      teams={filteredTeams}
      aces={aces}
      selectedUser={selectedUser}
      onSelectUser={handleChangeSelectedUser}
      onChangeAce={handleSaveAce}
      onSelectTeam={handleAddAce}
    />
  );
}
